<template>
  <div class="mblock_06">
    <div class="width_wrap">
      <div class="box1">
        <ul>
          <li
            style="
              width: 100%;
              border: 1px solid #ddd;
              padding: 20px;
              border-radius: 10px;
              position: relative;
            "
          >
            <h3 style="color: brown">1. 온라인 검사 실시 준비</h3>
            <ul>
              <li>단계 1-1. [신규]회원가입 및 로그인 (www.cokolab.com)</li>
              <li>
                단계 1-2.
                <span class="deep-brown">개인 예약 · 신청하기</span> 를 클릭 →
                검사 및 상담코칭 로 입장
              </li>
              <li>
                단계 1-3. 이용 상품의 기본정보를 확인 → 해당 상품의
                <span class="deep-brown"> 바로가기 </span>로 이동
              </li>
              <li>
                단계 1-4. 이용 상품을 예약, 신청하기 위한 신청서를 작성, 제출 →
                마이페이지 에서
                <span class="deep-brown">검사신청상세정보 수령</span> 확인 →
                <span class="deep-brown">결제</span>(계좌이체)
              </li>
              <li>
                단계 1-5. 피검자는
                <span class="deep-brown"> 검사 링크 및 인증코드 </span>를
                검사예정일 1일 전,
                <span class="deep-brown">Email로 수령</span>
              </li>
            </ul>
            <br />
            <h3 style="color: brown">2. 온라인 검사 실시</h3>
            <ul>
              <li>
                단계 2-1. 피검자는
                <span class="deep-brown"
                  >Email로 수령한 검사지 링크 및 인증코드를 확인함</span
                ><br />
                <span style="color: blue"
                  >※ 이용 기기: 피검자의 핸드폰, PC, 테블릿 PC</span
                >
              </li>
              <li>
                단계 2-2. 피검자는 Email을 열어,
                <span class="deep-brown">검사 시작</span> → 기본정보 입력/ 검사
                이해 및 안내 확인 →
                <span class="deep-brown">응답 – 완료 - 제출</span>
              </li>
            </ul>
            <br />
            <h3 style="color: brown">3. 검사 결과리포트 확인</h3>
            <ul>
              <li>
                단계 3. 검사 완료 직후, 검사 결과리포트 생성 및
                <span class="deep-brown">Email 발송</span>
              </li>
            </ul>
            <br />
            <h3 style="color: brown">4. 검사기반 상담코칭 이용 안내</h3>
            <ul>
              <li>
                단계 4. 검사 종료 및 결과리포트 수령 후, 개별 상담코칭 일정
                확인, 조율 (042-867-5558)
                <br /><span style="color: blue"
                  >※ 진행 방법: 내방 상담, 온라인 상담(ZOOM 이용)</span
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.sub04_wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.sub04_wrap > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.sub04_wrap > ul li {
  width: 48%;
}
.sub04_wrap > ul li figure {
  border: 1px solid #ddd;
}
.sub04_wrap > ul li:nth-child(-n + 2) {
  margin-bottom: 30px;
}
.sub04_wrap > ul li a {
  display: block;
  border-radius: 10px;
  position: relative;
  transition: all.2s;
}
.sub04_wrap > ul li h1 {
  font-size: 14px;
  font-weight: 500;
  padding-top: 15px;
  text-align: center;
}
.sub04_wrap > ul li a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.sub04_wrap > ul li a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}
@media screen and (min-width: 768px) {
  .sub04_wrap > ul {
    justify-content: normal;
  }
  .sub04_wrap > ul li h1 {
    font-size: 16px;
  }
  .sub04_wrap > ul li {
    width: 23.5%;
    margin-right: 2%;
  }
  .sub04_wrap > ul li:nth-child(-n + 2) {
    margin-bottom: 0px;
  }
  .sub04_wrap > ul li:last-child {
    margin-right: 0;
  }
  .sub04_wrap > ul li a:hover > div.bg {
    display: block;
    opacity: 1;
  }
  .mblock_06 > div > div > ul > li > ul > li span {
    padding: 0px 4px;
    display: inline-block;
    color: #fff;
    border-radius: 3px;
  }
  .mblock_06 > div > div > ul > li > ul > li span.green {
    background: #ba7b3d;
  }
  .mblock_06 > div > div > ul > li > ul > li span.brown {
    background: #b3897d;
  }
  .mblock_06 > div > div > ul > li > ul > li span.deep-brown {
    background: #b37b4c;
  }
  .mblock_06 > div > div > ul > li > ul > li span.blue {
    background: #6489d9;
  }
}
</style>
